import { useCallback } from 'react';
import { analytics } from '@/lib/analytics';
import { metaPixel } from '@/lib/metaPixel';

const BROCHURE_URL = '/brochure/nahar-chandi-valley-brochure.pdf';

export function useBrochureDownload() {
  const downloadBrochure = useCallback(() => {
    try {
      // Track the download event with GA4 + Meta Pixel
      analytics.brochureDownload(window.location.pathname);
      metaPixel.brochureDownload({ content_name: 'Nahar Chandi Valley Brochure' });

      // Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = BROCHURE_URL;
      link.download = 'Nahar-Chandi-Valley-Brochure.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return true;
    } catch (error) {
      console.error('Brochure download failed:', error);
      return false;
    }
  }, []);

  return { downloadBrochure, brochureUrl: BROCHURE_URL };
}